function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { applyAggregateErrorsToEvent } from '@sentry/utils';
import { exceptionFromError } from '../eventbuilder.js';
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */

var LinkedErrors = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  function LinkedErrors() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LinkedErrors);

    this.name = LinkedErrors.id;
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }
  /** @inheritdoc */


  _createClass(LinkedErrors, [{
    key: "setupOnce",
    value: function setupOnce() {// noop
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "preprocessEvent",
    value: function preprocessEvent(event, hint, client) {
      var options = client.getOptions();
      applyAggregateErrorsToEvent(exceptionFromError, options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'LinkedErrors';
    }
  }]);

  return LinkedErrors;
}();

LinkedErrors.__initStatic();

export { LinkedErrors };